import MonixModal from "@/global/components/monix-modal";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { ReactComponent as CheckSvg } from '@/global/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/global/icons/table/checked.svg';
import { GlobalDataBox } from "@/global/interface/lib-device/global-data-box";
import { useParams } from "react-router-dom";
import { getGlobalDataBoxes } from "@/api/lib/lib-data-box";
import TnMessage from "@/global/components/message";

interface IProps {
    dataBoxType: number
    visible: boolean
    setVisible: (value: boolean) => void
    onFinish: (values: number[]) => void
    loading: boolean
    filterItems: GlobalDataBox[]
}

export default function LinkGlobalDataBoxModal(props: IProps) {
    const [globalDataBoxes, setGlobalDataBoxes] = useState<GlobalDataBox[]>([]); // 可选的库采集箱
    const [selected, setSelected] = useState<number[]>([]); // 选中的库采集箱id


    // 初始化
    useEffect(() => {
        generateData();
    }, [])


    // 点击确认按钮
    const onSaveClick = () => {
        if (selected?.length === 0) {
            props.setVisible(false);
            return;
        }
        if (props?.onFinish) {
            props.onFinish(selected);
        }
    }

    // 获取数据
    const generateData = () => {
        getGlobalDataBoxes({ type: props.dataBoxType }).then(res => {
            let data: GlobalDataBox[] = res.data || [];
            if(props?.filterItems) {
                data = data?.filter(item => !props?.filterItems?.some(i => i.id === item.id)) || [];
            }
            setGlobalDataBoxes(data);
        })
    }

    return (
        <MonixModal
            title={"添加采集设备"}
            visible={props.visible}
            setVisible={(e) => props.setVisible(e)}
            onSaveClick={onSaveClick}
            wrapClassName="link-global-device-modal"
            saveDisable={props.loading}
        >
            <Spin wrapperClassName="link-global-device-body" spinning={props.loading}>
                <div className="link-body">
                    {globalDataBoxes?.length !== 0 && globalDataBoxes?.map((item, key) => (
                        <div className="link-item" key={key}>
                            <div className="item-icon" onClick={() => {
                                let idx = selected?.findIndex(g => g === item.id);
                                setSelected(prev => {
                                    if (idx === -1) {
                                        prev.push(item.id);
                                    } else {
                                        prev.splice(idx, 1);
                                    }
                                    return [...prev];
                                })
                            }}>
                                {!selected?.some(g => g === item.id) && <CheckSvg />}
                                {selected?.some(g => g === item.id) && <CheckedSvg />}
                            </div>
                            <div className="item-text">{`名称：${item?.name || ''}`}</div>
                            <div className="item-text">{`型号：${item?.marking || ''}`}</div>
                        </div>
                    ))}
                    {globalDataBoxes?.length === 0 && <div className="link-item">
                        <div className="item-text">{`暂无数据`}</div>
                    </div>
                    }
                </div>
            </Spin>
        </MonixModal>
    )
}